module.exports = __webpack_public_path__ + "img/buyer.6314f664.png";